export default "__VITE_ASSET__b277bf0b__"